
import { h } from 'preact';
import * as BaseComp from 'components/bolt/signUpForm/signUpForm.js';
import { STRICTLY_NECESSARY, PERFORMANCE, FUNCTIONAL, TARGETING } from 'utils/gdpr/constants';
import * as categories from 'utils/gdpr/categories';
import { accessNested } from 'utils/utils';
import Store from 'store/store';
export default class SignUpForm extends BaseComp.default {
	checkIfCanShowBanner() {
		const waitForCookie = accessNested(Store.get(), 'appData.options.formEmbeds.signUp.waitforCookie');
		const useEnsightenCookieConsent = accessNested(Store.get(), 'appData.options.enableEnsighten');
		if (waitForCookie) {
			if (!useEnsightenCookieConsent && (!categories.has(PERFORMANCE) || !categories.has(FUNCTIONAL) || !categories.has(TARGETING))) {
				return false;
			}
			if (useEnsightenCookieConsent && (!categories.has(PERFORMANCE) || !categories.has(TARGETING))) {
				return false;
			}
		}
		return super.checkIfCanShowBanner();
	}
	componentDidMount() {
		super.componentDidMount?.();
		categories.addChangeListener(this.checkIfCanShowBanner);
	}

	componentWillUnmount() {
		super.componentWillUnmount?.();
		categories.removeChangeListener(this.checkIfCanShowBanner);
	}
}